<template>
  <span class="border-white inline-block border-2 rounded-full h-24 w-24 animate-bubble" style="transform: scale(0);"></span>
</template>

<script>
    export default {
        name: "Pulse"
    }
</script>
